import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Blockchain: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      fill: 'none',
      width: '32px',
      height: '32px',
      ...sx,
    }}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25781 9.88628V6.11295C3.25781 5.63161 3.51781 5.18761 3.93781 4.95028L7.34581 3.03428C7.75115 2.80628 8.24715 2.80628 8.65381 3.03428L12.0618 4.95161C12.4818 5.18761 12.7418 5.63161 12.7418 6.11428V9.88761C12.7418 10.3689 12.4818 10.8129 12.0618 11.0503L8.65248 12.9649C8.24715 13.1929 7.75115 13.1929 7.34448 12.9649L3.93781 11.0489C3.51781 10.8129 3.25781 10.3676 3.25781 9.88628Z"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8.0026 8V13.1333" stroke="#090C18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8 7.99945L12.56 5.43945"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.9975 7.99945L3.4375 5.43945"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M19.2567 8.00065H12.75" stroke="#090C18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2578 9.88566V6.11233C19.2578 5.63099 19.5178 5.18699 19.9378 4.94966L23.3458 3.03233C23.7511 2.80433 24.2471 2.80433 24.6538 3.03233L28.0618 4.94966C28.4818 5.18566 28.7418 5.62966 28.7418 6.11233V9.88566C28.7418 10.367 28.4818 10.811 28.0618 11.0483L24.6525 12.9643C24.2471 13.1923 23.7511 13.1923 23.3445 12.9643L19.9365 11.047C19.5178 10.8123 19.2578 10.367 19.2578 9.88566H19.2578Z"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M24.0026 8V13.1333" stroke="#090C18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M24 7.99945L28.56 5.43945"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.9975 7.99945L19.4375 5.43945"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25781 25.8857V22.1123C3.25781 21.631 3.51781 21.187 3.93781 20.9497L7.34581 19.0323C7.75115 18.8043 8.24715 18.8043 8.65381 19.0323L12.0618 20.9497C12.4818 21.1857 12.7418 21.6297 12.7418 22.1123V25.8857C12.7418 26.367 12.4818 26.811 12.0618 27.0483L8.65248 28.9643C8.24715 29.1923 7.75115 29.1923 7.34448 28.9643L3.93648 27.047C3.51781 26.8123 3.25781 26.367 3.25781 25.8857H3.25781Z"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8.0026 24V29.1333" stroke="#090C18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8 23.9995L12.56 21.4395"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.9975 23.9995L3.4375 21.4395"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M19.2567 24.0007H12.75" stroke="#090C18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M24.0026 18.8661V13.1328"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8.0026 18.8661V13.1328" stroke="#090C18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2578 25.8857V22.1123C19.2578 21.631 19.5178 21.187 19.9378 20.9497L23.3458 19.0323C23.7511 18.8043 24.2471 18.8043 24.6538 19.0323L28.0618 20.9497C28.4818 21.1857 28.7418 21.6297 28.7418 22.1123V25.8857C28.7418 26.367 28.4818 26.811 28.0618 27.0483L24.6538 28.9657C24.2485 29.1937 23.7525 29.1937 23.3458 28.9657L19.9378 27.0483C19.5178 26.8123 19.2578 26.367 19.2578 25.8857Z"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M24.0026 24V29.1333" stroke="#090C18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M24 23.9995L28.56 21.4395"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.9975 23.9995L19.4375 21.4395"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
